// extracted by mini-css-extract-plugin
module.exports = {"inverted-radius":"styles_inverted-radius__ECUgJ","inverted-radius-top":"styles_inverted-radius-top__weDYb","inverted-radius-bottom":"styles_inverted-radius-bottom____IZM"};